export default "__VITE_ASSET__f431ed96__"